import React, { Component } from "react"

export default class ollies extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Ollies</p>
            <p className="portdesctext">Freelance branding, digital marketing, & design work for Cafe in Aotearoa. Designed the logo & digital assets in Adobe suite, developed & deployed website using Django & AWS, setup email server in G-suiet.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="http://www.ollies.cafe" target="_blank" rel="noopener noreferrer"><p className="linktext">Site</p></a>
        </div>
      </div>
  )
}
}

